import { IComponentAsset, IComponentManifest } from '../../registry.types';
import {
  getExtension,
  isJS,
  getAssetsTypeByExtension,
} from '../../toolbox/assets';

export function createComponentManifestBuilder({ name }: { name: string }) {
  const componentManifest: IComponentManifest = {
    name,
    assets: [],
    parts: {},
  };

  return {
    addUrl(id: string, url: string) {
      componentManifest.id = id;
      componentManifest.url = url;

      this.addModelAsset(id, url);

      return this;
    },

    addPart(id: string, part: string, url: string, eager: boolean = false) {
      componentManifest.parts[part] = { id, url, eager };

      this.addModelAsset(id, url, part);

      return this;
    },

    addModelAsset(id: string, url: string, part?: string) {
      componentManifest.assets.push({
        id,
        url,
        type: 'model',
        extension: 'js',
        part,
      });
      return this;
    },

    addStyleAsset(url: string, part?: string) {
      componentManifest.assets.push({
        url,
        type: 'style',
        extension: 'css',
        part,
      });
      return this;
    },

    addDeps(deps: Array<string>) {
      componentManifest.deps = deps.filter(url => isJS(getExtension(url)));
      componentManifest.assets.push(
        ...deps.map(url => {
          const extension = getExtension(url) as string;

          return {
            url,
            type: getAssetsTypeByExtension(extension),
            extension,
            dependency: true,
          };
        }),
      );
    },

    filterAssets(predicate: (asset: IComponentAsset) => boolean) {
      componentManifest.assets = componentManifest.assets.filter(predicate);
    },

    build() {
      return {
        ...componentManifest,
      };
    },
  };
}
